import { defineComponent as _defineComponent } from 'vue'
import { postModerationWarningText } from '@@/bits/post_moderation'
import type { ModerationCategories } from '@@/enums'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostModeration',
  props: {
    colorScheme: null,
    moderationViolations: null
  },
  emits: ['reject', 'approve'],
  setup(__props: any, { emit }) {

const props = __props as {
  colorScheme: 'light' | 'dark'
  moderationViolations: ModerationCategories[]
}





const surfaceStore = useSurfaceStore()
const { isFrozen, isStream } = storeToRefs(surfaceStore)

const xContentModerationWarning = computed<boolean>(() => {
  return !!props.moderationViolations && props.moderationViolations.length > 0
})

const warningText = computed<string>(() => {
  return postModerationWarningText({ moderationViolations: props.moderationViolations, useLongText: isStream.value })
})

const rejectPost = (): void => {
  emit('reject')
}

const approvePost = (): void => {
  emit('approve')
}

return { __sfc: true,props, emit, surfaceStore, isFrozen, isStream, xContentModerationWarning, warningText, rejectPost, approvePost, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzIcon }
}

})